// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "assets_3.25.0/js/[name].bundle" + "-" + "925e0129cf8ea666b4d8" + "-bundle.js";
};